import facebookLogo from '../assets/img/icons/Facebook_logo.svg';
import productPlaceholder from '../assets/img/product_placeholder.jpg';

export { facebookLogo, productPlaceholder };

export const messageIcons = {
  accessories: new URL('../assets/img/icons/icon-accessories.svg', import.meta.url).href,
  action: new URL('../assets/img/icons/icon-action.svg', import.meta.url).href,
  'added-to-cart': new URL('../assets/img/icons/icon-added-to-cart.svg', import.meta.url).href,
  bike: new URL('../assets/img/icons/icon-bike.svg', import.meta.url).href,
  builder: new URL('../assets/img/icons/icon-builder.svg', import.meta.url).href,
  documents: new URL('../assets/img/icons/icon-documents.svg', import.meta.url).href,
  error: new URL('../assets/img/icons/icon-error.svg', import.meta.url).href,
  guidelines: new URL('../assets/img/icons/icon-guidelines.svg', import.meta.url).href,
  info: new URL('../assets/img/icons/icon-info.svg', import.meta.url).href,
  orders: new URL('../assets/img/icons/icon-orders.svg', import.meta.url).href,
  outlet: new URL('../assets/img/icons/icon-outlet.svg', import.meta.url).href,
  parts: new URL('../assets/img/icons/icon-parts.svg', import.meta.url).href,
  promo: new URL('../assets/img/icons/icon-promo.svg', import.meta.url).href,
  question: new URL('../assets/img/icons/icon-question.svg', import.meta.url).href,
  success: new URL('../assets/img/icons/icon-success.svg', import.meta.url).href,
  'tag-euro': new URL('../assets/img/icons/icon-tag-euro.svg', import.meta.url).href,
  update: new URL('../assets/img/icons/icon-update.svg', import.meta.url).href,
  warning: new URL('../assets/img/icons/icon-warning.svg', import.meta.url).href,
};

export const connectionLogos = {
  xlsx: new URL('../assets/img/brands/BCF-hori-pos-cmyk-XLSX.png', import.meta.url).href,
  csv: new URL('../assets/img/brands/BCF-hori-pos-cmyk-CSV.png', import.meta.url).href,
  json: new URL('../assets/img/brands/BCF-hori-pos-cmyk-JSON.png', import.meta.url).href,
  advanced: new URL('../assets/img/brands/BCF-hori-pos-cmyk-ADV.png', import.meta.url).href,
  config: new URL('../assets/img/brands/BCF-hori-pos-cmyk-CONFIG.png', import.meta.url).href,
  stock: new URL('../assets/img/brands/BCF-hori-pos-cmyk-Stock.png', import.meta.url).href,
  cyclesoftware: new URL('../assets/img/brands/cyclesoftware-transp.png', import.meta.url).href,
  shopify: new URL('../assets/img/brands/shopify.png', import.meta.url).href,
  channable: new URL('../assets/img/brands/channable2.png', import.meta.url).href,
  veloconnect: new URL('../assets/img/brands/veloconnect.png', import.meta.url).href,
  dst: new URL('../assets/img/brands/dst.png', import.meta.url).href,
  bidex: new URL('../assets/img/brands/logo-bidex-06102026.png', import.meta.url).href,
  tridata: new URL('../assets/img/brands/tridata.png', import.meta.url).href,
  citruslime: new URL('../assets/img/brands/citruslime.jpg', import.meta.url).href,
  ascend: new URL('../assets/img/brands/Ascend.png', import.meta.url).href,
  velodata: new URL('../assets/img/brands/Velodata.png', import.meta.url).href,
  odoo: new URL('../assets/img/brands/odoo.png', import.meta.url).href,
  combase: new URL('../assets/img/brands/combase.png', import.meta.url).href,
  veloport: new URL('../assets/img/brands/veloport.png', import.meta.url).href,
  bigshift: new URL('../assets/img/brands/bigshift.png', import.meta.url).href,
  approom: new URL('../assets/img/brands/approom.png', import.meta.url).href,
  evendo: new URL('../assets/img/brands/e-vendo.png', import.meta.url).href,
  servibikes: new URL('../assets/img/brands/servibikes.png', import.meta.url).href,
  tricoma: new URL('../assets/img/brands/tricoma.png', import.meta.url).href,
  hiw: new URL('../assets/img/brands/hiw.png', import.meta.url).href,
  lacash: new URL('../assets/img/brands/lacash.png', import.meta.url).href,
  radfak: new URL('../assets/img/brands/radfak.png', import.meta.url).href,
  cycly: new URL('../assets/img/brands/cycly.png', import.meta.url).href,
  famowa: new URL('../assets/img/brands/famowa.png', import.meta.url).href,
  hbs: new URL('../assets/img/brands/hbs.png', import.meta.url).href,
  hgi: new URL('../assets/img/brands/hgi.png', import.meta.url).href,
  mention: new URL('../assets/img/brands/mention.png', import.meta.url).href,
  wintersteiger: new URL('../assets/img/brands/wintersteiger.png', import.meta.url).href,
  xentral: new URL('../assets/img/brands/xentral.png', import.meta.url).href,
};

export const sharepointLogos = {
  ridley: new URL('../assets/img/brands/logo/ridley_full.svg', import.meta.url).href,
  merckx: new URL('../assets/img/brands/logo/merckx_full.svg', import.meta.url).href,
  nukeproof: new URL('../assets/img/brands/logo/nukeproof_full.svg', import.meta.url).href,
  aeres: new URL('../assets/img/brands/logo/aeres_full.svg', import.meta.url).href,
  forza: new URL('../assets/img/brands/logo_forza_small.png', import.meta.url).href,
  bcf: new URL('../assets/img/bcf-logo.svg', import.meta.url).href,
};
